module.exports = __webpack_public_path__ + "media/application/images/svgs/terminal-a5b627a9c0bde7ce43c6b3fa719967a9.svg";